import React, { useMemo, useRef, useState } from "react";
import { useCopyToClipboard } from "react-use"; // TODO: wait for the mr merged https://github.com/react-hookz/web/pull/883/files#diff-0db06a79ebb52478c3ff555b5441ced52d7695b2523c22ee663b4d6cfb1e6249

import { theme, useResponsive } from "~/lib/media";
import { Button, StyledPopper, Tooltip } from "./styles";
export const CopyLinkButton = ({
  children,
  className,
  disablePortal = true,
  LabelComponent,
  onClick,
  showLabel,
  tooltipPlacement = "right",
  url,
  variant
}) => {
  const [_, copyToClipboard] = useCopyToClipboard();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [hasCopied, setHasCopied] = useState(false);
  const tooltipAnchorReference = useRef(null);
  const isTabletUp = useResponsive(theme.breakpoints.up("tablet"));
  const handleClick = () => {
    copyToClipboard(url);
    const handleTooltipAction = () => {
      setIsTooltipOpen(true);
      setTimeout(() => {
        setIsTooltipOpen(false);
        onClick === null || onClick === void 0 || onClick();
      }, 1000);
    };
    const handleLabelAction = () => {
      copyToClipboard(url);
      setHasCopied(true);
      onClick === null || onClick === void 0 || onClick();
    };
    switch (variant) {
      case "tooltip":
        handleTooltipAction();
        break;
      case "label":
        handleLabelAction();
        break;
      case "responsive":
        isTabletUp ? handleTooltipAction() : handleLabelAction();
        break;
    }
  };
  const renderTooltipValue = () => {
    const tooltipLabelValue = "Copy Link";
    const labelVariantValue = hasCopied ? "Link Copied" : "Copy Link";
    switch (variant) {
      case "tooltip":
        return tooltipLabelValue;
      case "label":
        return labelVariantValue;
      case "responsive":
        isTabletUp ? tooltipLabelValue : labelVariantValue;
        break;
    }
  };
  const popperModifiers = useMemo(() => [{
    name: "offset",
    options: {
      offset: [0, 12]
    }
  }], []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: className,
    ref: tooltipAnchorReference,
    type: "button",
    onClick: () => handleClick()
  }, children, showLabel && /*#__PURE__*/React.createElement(LabelComponent, null, renderTooltipValue())), /*#__PURE__*/React.createElement(StyledPopper, {
    anchorEl: tooltipAnchorReference.current,
    disablePortal: disablePortal,
    modifiers: popperModifiers,
    open: isTooltipOpen,
    placement: tooltipPlacement
  }, /*#__PURE__*/React.createElement(Tooltip, null, "Link Copied")));
};
CopyLinkButton.displayName = "CopyLinkButton";